module.exports = __webpack_public_path__ + "media/images/payments/sage-0980633357b5ff682f74ef8697e9109f.svg";